import React, {Component} from "react";
import {connect} from 'react-redux';
import {Collapse, Input, Spin, Table} from "antd";
import {toLocaleString} from "../../../../UserService/Common/utils";

const Panel = Collapse.Panel;

class AlgorithmDetail extends Component {

  constructor() {
    super();
    this.renderParameter = this.renderParameter.bind(this);
  }

  render() {
    console.debug("AlgorithmDetail:", this.props.selectId, this.props.selectType, this.props.algorithmMap[this.props.nodeId]);
    const algorithmInfo = this.props.algorithmMap[this.props.nodeId] ? this.props.algorithmMap[this.props.nodeId].algorithmInfo : null;

    if (algorithmInfo === null)
      return null;

    let columns = [{
      title: "name",
      dataIndex: "name",
      key: "name",
      width: 100,
    }, {
      title: "value",
      dataIndex: "value",
      key: "value"
    }];

    let data = [{
      key: "1",
      name: "名称",
      value: algorithmInfo.name
    }, {
      key: "2",
      name: "关键字",
      value: algorithmInfo.keyword ? algorithmInfo.keyword : "N/A"
    }, {
      key: "3",
      name: "域",
      value: algorithmInfo.algorithmFileId ? algorithmInfo.algorithmFileId : "N/A"
    }, {
      key: "4",
      name: "创建人",
      value: algorithmInfo.createByName ? algorithmInfo.createByName : "N/A"
    }, {
      key: "5",
      name: "创建时间",
      value: algorithmInfo.createDate ? toLocaleString(algorithmInfo.createDate) : "N/A"
    }, {
      key: "6",
      name: "更新人",
      value: algorithmInfo.updateByName ? algorithmInfo.updateByName : "N/A"
    }, {
      key: "7",
      name: "更新时间",
      value: algorithmInfo.updateDate ? toLocaleString(algorithmInfo.updateDate) : "N/A"
    }, {
      key: "8",
      name: "是否启用",
      value: algorithmInfo.enabled ? "是" : "否"
    }];


    return (
      <Spin spinning={algorithmInfo === ""} size="large">
        <Collapse bordered={false} defaultActiveKey={["1"]}>
          <Panel header="算法基础信息" key="1">
            <div style={{
              display: "flex"
            }}>
              {/*<div>
                <div className="ds-detail-label">名称:</div>
                <div className="ds-detail-label">关键字:</div>
                <div className="ds-detail-label">域:</div>
                <div className="ds-detail-label">创建人:</div>
                <div className="ds-detail-label">创建时间:</div>
                <div className="ds-detail-label">更新人:</div>
                <div className="ds-detail-label">更新时间:</div>
                <div className="ds-detail-label">是否启用:</div>
              </div>
              <div style={{minWidth: 100}}>
                <div className="ds-detail-info">{algorithmInfo.name}</div>
                <div className="ds-detail-info">{algorithmInfo.keyword ? algorithmInfo.keyword : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.algorithmFileId ? algorithmInfo.algorithmFileId : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.createByName ? algorithmInfo.createByName : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.createDate ? toLocaleString(algorithmInfo.createDate) : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.updateByName ? algorithmInfo.updateByName : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.updateDate ? toLocaleString(algorithmInfo.updateDate) : "N/A"}</div>
                <div className="ds-detail-info">{algorithmInfo.enabled ? "是" : "否"}</div>
              </div>*/}
              <Table columns={columns} dataSource={data} showHeader={false} pagination={false}/>
            </div>
          </Panel>
          <Panel header="算法简介" key="2">
            <div style={{paddingLeft: 16}}>{algorithmInfo.description}</div>
          </Panel>
          <Panel header="算法参数" key="3">
            <div>
              {
                this.renderParameter(this.props.algorithmMap[this.props.nodeId].normalInputParams)
              }
            </div>
          </Panel>
          <Panel header="算法执行结果" key="4">
            {
              <div style={{paddingLeft: 16}}>
                {this.props.algorithmMap[this.props.nodeId].algorithmStatus ?
                  this.props.algorithmMap[this.props.nodeId].algorithmStatus : "N/A"}
              </div>
            }
          </Panel>
        </Collapse>
      </Spin>
    )
  }

  renderParameter(params) {

    let columns = [{
      title: "name",
      dataIndex: "name",
      key: "name",
      width: 100,
    }, {
      title: "value",
      dataIndex: "value",
      key: "value",
      render: (text, record) => {
        return <Input name={record.name}
                      value={record.value}
                      placeholder={record.description}
                      onChange={e => this.props.updateAlgorithmParam({
                        name: e.target.name,
                        value: e.target.value,
                        nodeId: this.props.nodeId
                      })}/>
      }
    }];

    let data = params.map((param, index) => {
      return {
        key: index,
        name: param.name,
        value: param.value,
        description: param.description
      }
    });

    return (
      <Table columns={columns} dataSource={data} showHeader={false} pagination={false}/>
    );

    /*return params.map(param => {
      return (
        <div key={param.id}>
          <label>{param.name}</label>
          <Input
            name={param.name}
            value={param.value}
            placeholder={param.description}
            onChange={e => this.props.updateAlgorithmParam({
              name: e.target.name,
              value: e.target.value,
              nodeId: this.props.nodeId
            })}/>
        </div>
      )
    })*/
  }
}

export const mapStateToProps = (state) => {
  return {
    selectId: state.projectPanel.selectId,
    selectType: state.projectPanel.selectType,
    nodeId: state.projectPanel.nodeId
  }
};

export const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AlgorithmDetail);
